import { useRouter } from "next/router";
import parse from "html-react-parser";
import React from "react";
import Head from "next/head";
import { motion } from "framer-motion";
import Layout from "../../components/layout";
import { SectionBuilder, Section, HeroJobPosition } from "../../components";
import { getPostTypeList, getData } from "../../services/API";

export const getStaticProps = async ({ params, locale, preview }) => {
  const entities = ["getJobOpening"];
  const { page, mainMenuData, footerData } = await getData({
    entities,
    id: params.id,
    locale,
    preview,
  });

  return {
    props: {
      mainMenuData,
      fullData: page[0],
      componentsData: page[0].acf,
      seoData: page[0].yoast_head,
      seoSchema: page[0].yoast_head_json.schema,
      reelData: page[0].reel,
      footerData,
      hrefLangs: page[0].hreflangs,
    },
    revalidate: 30,
  };
};

export const getStaticPaths = async ({ locales }) => {
  const entities = ["jobs"];
  const [cases] = await Promise.all(
    entities.map((ent) => getPostTypeList(ent, locales))
  );

  return {
    paths: cases,
    fallback: false,
  };
};

const Cases = ({
  fullData,
  componentsData,
  footerData,
  mainMenuData,
  reelData,
  seoData,
  seoSchema,
  hrefLangs,
}) => {
  const { locale } = useRouter();
  const yoastHead = parse(seoData);

  return (
    <>
      <Layout
        footerData={footerData}
        mainMenuData={mainMenuData}
        reelData={reelData}
      >
        <Head>
          {yoastHead}
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(seoSchema) }}
          />

          {/* {hrefLangs[0] && (
            <link
              rel="alternate"
              href={hrefLangs[0].url}
              hrefLang={hrefLangs[0].lang_code}
            />
          )}
          {hrefLangs[1] && (
            <link
              rel="alternate"
              href={hrefLangs[1].url}
              hrefLang={hrefLangs[1].lang_code}
            />
          )}
          {hrefLangs[0] && (
            <link
              rel="alternate"
              href={hrefLangs[0].url}
              hrefLang="x-default"
            />
          )} */}
        </Head>

        {fullData.acf.closed ? (
          <Section variant="dark" data-extra-bg="false">
            <HeroJobPosition
              title={fullData.title.rendered}
              text={
                locale == "en"
                  ? "We are sorry, we are no longer accepting applications for this position or you landed here due to an outdated link. Please return to all positions to continue with your search."
                  : "Ci dispiace, non riceviamo più candidature per questa posizione o sei atterrato qui tramite un link datato. Torna a tutte le posizioni per continuare con la tua ricerca."
              }
              ctaAllCareers={{
                label: `${
                  locale == "en"
                    ? "See all open positions"
                    : "Scopri tutte le posizioni aperte"
                }`,
                url: `/${locale == "en" ? "en" : ""}/jobs`,
              }}
            />
          </Section>
        ) : (
          <SectionBuilder data={componentsData} />
        )}
      </Layout>
    </>
  );
};
export default Cases;
